import { InputAdvisability } from 'views/components/molecules/establishes/inputAdvisability';
import { InputChoices } from 'views/components/molecules/establishes/inputChoices';
import { InputLetter } from 'views/components/molecules/establishes/inputLetter';
import {
  EmploymentFormikType,
  ListedCompanyPostStrs,
  PofessionStrs,
  ListedCompanyPost,
  FormErrorScrollTarget,
} from 'views/utils/accountEstablish';
import { Button, ButtonProps } from 'views/components/atoms/button';
import { EstablishCheckProps } from 'views/components/atoms/establishes/check';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishText, MaskType } from 'views/components/atoms/establishes/text';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ja from 'date-fns/locale/ja';
registerLocale('ja', ja);

type EmploymentTemplateType = {
  formik: EmploymentFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
    confirmButtonProps: ButtonProps;
    isPrevPageConfirm: boolean;
  };
  checkButtonProps: {
    isNoWorkplaceButtonProps: EstablishCheckProps;
    isNoDepartmentButtonProps: EstablishCheckProps;
    isNoPostButttonProps: EstablishCheckProps;
    isNoWorkPhoneNumberButtonProps: EstablishCheckProps;
  };
  isWorkPhoneNumberMask: boolean;
};

export const EmploymentTemplate = ({
  formik,
  buttonProps,
  checkButtonProps,
  isWorkPhoneNumberMask,
}: EmploymentTemplateType) => {
  return (
    <>
      <div className="establishWrapper">
        {!!formik.errors.profession && <FormErrorScrollTarget />}
        <InputChoices
          title="ご職業"
          batchDangerWord="必須"
          selectedOption={formik.values.profession ? formik.values.profession : ''}
          setSelectedOption={(selectedOption) => formik.setFieldValue('profession', selectedOption)}
          options={PofessionStrs}
          isEnabled={!!formik.errors.profession}
          errorText={formik.errors.profession}
        />
      </div>
      <div className="establishWrapper">
        {!!formik.errors.workplace && <FormErrorScrollTarget />}
        <InputLetter
          inputType="text"
          title="お勤め先名称 or 屋号"
          inputValue={formik.values.workplace ?? undefined}
          setInputValue={(e) => formik.setFieldValue('workplace', e.target.value)}
          batchDangerWord="必須"
          isEnable={!!formik.errors.workplace}
          errorText={formik.errors.workplace}
          placeholder="お勤め先名称 or 屋号"
          checkButtonProps={checkButtonProps.isNoWorkplaceButtonProps}
        />
        <span className="establishWrapper_description">
          ※名称に株式会社等の表記がある場合には、「株式会社」等もご入力ください（例：株式会社〇〇、〇〇株式会社）
        </span>
      </div>

      <div className="establishWrapper">
        {!!formik.errors.department && <FormErrorScrollTarget />}
        <InputLetter
          inputType="text"
          title="所属部署"
          inputValue={formik.values.department ?? undefined}
          setInputValue={(e) => formik.setFieldValue('department', e.target.value)}
          batchDangerWord="必須"
          isEnable={!!formik.errors.department}
          errorText={formik.errors.department}
          placeholder="所属部署"
          checkButtonProps={checkButtonProps.isNoDepartmentButtonProps}
        />
      </div>

      <div className="establishWrapper">
        {!!formik.errors.post && <FormErrorScrollTarget />}
        <InputLetter
          inputType="text"
          title="ご役職"
          inputValue={formik.values.post ?? undefined}
          setInputValue={(e) => formik.setFieldValue('post', e.target.value)}
          batchDangerWord="必須"
          isEnable={!!formik.errors.post}
          errorText={formik.errors.post}
          placeholder="ご役職"
          checkButtonProps={checkButtonProps.isNoPostButttonProps}
        />
      </div>

      <div className="establishWrapper">
        {!!formik.errors.workPhoneNumber && <FormErrorScrollTarget />}
        <InputLetter
          inputType="tel"
          title="お勤め先電話番号"
          inputValue={formik.values.workPhoneNumber ?? undefined}
          setInputValue={(e) => formik.setFieldValue('workPhoneNumber', e.target.value)}
          batchDangerWord="必須"
          isEnable={!!formik.errors.workPhoneNumber}
          errorText={formik.errors.workPhoneNumber}
          placeholder="例:0312345678（ハイフン不要）"
          checkButtonProps={checkButtonProps.isNoWorkPhoneNumberButtonProps}
          masked={isWorkPhoneNumberMask ? { type: MaskType.Start, displayedCount: 4 } : undefined}
        />
      </div>

      <div className="establishWrapper">
        {!!formik.errors.listedCompanyCheck && <FormErrorScrollTarget />}
        <InputAdvisability
          title="上場会社該当者チェック"
          description="お勤め先やその親会社・子会社が上場会社に該当するか、配偶者または同居者が上場会社の役員等に該当するかのチェックです。当欄で「該当する」を選択して新たに表示される次欄「上場会社等の役職」に適当な選択肢がない場合、当欄は「該当しない」を選択してください。"
          name="listedCompanyCheck"
          batchDangerWord="必須"
          agreeText="該当する"
          denialText="該当しない"
          agreeValue="true"
          denialValue="false"
          checked={formik.values.listedCompanyCheck ?? undefined}
          onChange={(checked) => formik.setFieldValue('listedCompanyCheck', checked)}
          isEnabled={!!formik.errors.listedCompanyCheck}
          errorText={formik.errors.listedCompanyCheck}
        />
      </div>
      {formik.values.listedCompanyCheck && (
        <>
          <div className="establishWrapper hiddenBg">
            <div className="establishWrapper_announce">
              <h1>上場会社該当者の場合は以下もご記入ください</h1>
            </div>
            {!!formik.errors.listedCompanyPost && <FormErrorScrollTarget />}
            <InputChoices
              title="上場会社等の役職等"
              batchDangerWord="必須"
              selectedOption={formik.values.listedCompanyPost ? formik.values.listedCompanyPost : ''}
              setSelectedOption={(selectedOption) => formik.setFieldValue('listedCompanyPost', selectedOption)}
              options={ListedCompanyPostStrs}
              isEnabled={!!formik.errors.listedCompanyPost}
              errorText={formik.errors.listedCompanyPost}
            />
            {!!formik.errors.listedCompanyName && <FormErrorScrollTarget />}
            <InputLetter
              inputType="text"
              title="上場会社名"
              inputValue={formik.values.listedCompanyName ?? undefined}
              setInputValue={(e) => formik.setFieldValue('listedCompanyName', e.target.value)}
              batchDangerWord="必須"
              isEnable={!!formik.errors.listedCompanyName}
              errorText={formik.errors.listedCompanyName}
              placeholder="上場会社名"
            />
          </div>
          {formik.values.listedCompanyPost !== null &&
            formik.values.listedCompanyPost !== ListedCompanyPost.OFFICER_FAMIRY && (
              <div className="establishWrapper hiddenBg">
                <div className="establishWrapper_announce">
                  <h1>社外役員である場合は以下もご記入ください</h1>
                </div>
                {!!formik.errors.outSidePost && <FormErrorScrollTarget />}
                <InputLetter
                  inputType="text"
                  title="社外役員の場合のご役職"
                  inputValue={formik.values.outSidePost ?? undefined}
                  setInputValue={(e) => formik.setFieldValue('outSidePost', e.target.value)}
                  isEnable={!!formik.errors.outSidePost}
                  errorText={formik.errors.outSidePost}
                  placeholder="社外役員の場合のご役職"
                />

                <div className="inputWrapper">
                  {!!formik.errors.retirementDate && <FormErrorScrollTarget />}
                  <EstablishHeader headerTitle={'退任から1年以内の方は退任日をご記入ください'} />
                  <DatePicker
                    className="datePicker"
                    onChange={(d: Date) => {
                      formik.setFieldValue('retirementDate', !!d ? d.toLocaleDateString() : null);
                    }}
                    selected={!!formik.values.retirementDate ? new Date(formik.values.retirementDate) : null}
                    dateFormat="yyyy/MM/dd"
                    locale="ja"
                    dateFormatCalendar="yyyy年 MM月"
                    showPopperArrow={false}
                    openToDate={new Date('2022/01/01')}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="YYYY/MM/DD"
                  />
                  <EstablishError isEnabled={!!formik.errors.retirementDate} errorText={formik.errors.retirementDate} />
                </div>
              </div>
            )}
          {formik.values.listedCompanyPost !== null &&
            formik.values.listedCompanyPost === ListedCompanyPost.OFFICER_FAMIRY && (
              <div className="establishWrapper hiddenBg">
                <div className="establishWrapper_announce">
                  <h1>上場会社等の役員の配偶者または同居者である場合は以下もご記入ください</h1>
                </div>
                <div className="inputWrapper">
                  {(!!formik.errors.insiderBoardMemberFirstName || !!formik.errors.insiderBoardMemberLastName) && (
                    <FormErrorScrollTarget />
                  )}
                  <EstablishHeader headerTitle={'役員の氏名'} batchDangerWord="必須" />
                  <div className="flexWrapper">
                    <EstablishText
                      inputType="text"
                      inputValue={formik.values.insiderBoardMemberLastName ?? undefined}
                      setInputValue={(e) => formik.setFieldValue('insiderBoardMemberLastName', e.target.value)}
                      placeholder="姓"
                    />
                    <EstablishText
                      inputType="text"
                      inputValue={formik.values.insiderBoardMemberFirstName ?? undefined}
                      setInputValue={(e) => formik.setFieldValue('insiderBoardMemberFirstName', e.target.value)}
                      placeholder="名"
                    />
                  </div>

                  <div className="flexWrapper">
                    <EstablishError
                      isEnabled={
                        !!formik.errors.insiderBoardMemberFirstName || !!formik.errors.insiderBoardMemberLastName
                      }
                      errorText={formik.errors.insiderBoardMemberFirstName || formik.errors.insiderBoardMemberLastName}
                    />
                    {/* <EstablishError
                      isEnabled={!!formik.errors.insiderBoardMemberLastName}
                      errorText={formik.errors.insiderBoardMemberLastName}
                    /> */}
                  </div>
                </div>
              </div>
            )}
        </>
      )}
      {buttonProps && (
        <div className="establishWrapper">
          {buttonProps.isPrevPageConfirm ? (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.confirmButtonProps} />
            </div>
          ) : (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.prevButtonProps} />
              <Button {...buttonProps.nextButtonProps} />
            </div>
          )}
        </div>
      )}
    </>
  );
};
